export const contentAdreses = [
    { title: 'Оптимизация изображений:', url: 'https://tinypng.com/' },
    { title: 'Изображения:', url: 'https://postimages.org/' },
    { title: 'Аудиозаписи:', url: 'https://www.dropbox.com/' }
]